import type {QueryClient, QueryKey} from "@tanstack/react-query";

export async function invalidatePageQueries(queryClient: QueryClient, queryKey: QueryKey) {
  await queryClient.cancelQueries({queryKey});
  await queryClient.invalidateQueries({queryKey});
}
